module.exports = __webpack_public_path__ + "img/salon41roundtrans.615e021a.png";